<template>
  <div>
    <Navbar />
    <div style="display: flex; align-items: center; justify-content: center;" class="sections--bg" v-if="id === 0">
      <video id="collection-video" width="100%" src="@/assets/img/banners/technique.mp4" controls autoplay></video>
    </div>
    <Blogs @changeTab="changeTab($event)"/>
    <Games />
    <Cta />
    <Footer />
    <FloatButton />
  </div>
</template>

<script>
import Navbar from "../components/TheNavbar";
import Cta from "../components/TheCta.vue";
import Games from "../components/TheGames.vue";
import Footer from "../components/TheFooter";
import Blogs from "../components/TheBlog.vue";
import FloatButton from "../components/TheFloatingButton.vue";

export default {
  name: "Blog",
  components: {
    Navbar,
    Cta,
    Games,
    Footer,
    Blogs,
    FloatButton
  },
  data() {
    return {
      id: 0
    };
  },
  created() {
    this.id = parseInt(this.$route.params.id)
    window.scrollTo(0, 0);
  },
  methods: {
    changeTab(event) {
      this.id = event
    }
  }
};
</script>

<style lang="scss" scoped></style>
